import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAppBar,{staticClass:"noPrint",staticStyle:{"z-index":"1049"},attrs:{"dense":"","dark":"","fixed":"","clipped-left":"","color":"#2c2e3e","app":""}},[_c(VToolbarTitle,[_c(VImg,{attrs:{"src":require("@/assets/inncash-logo-white.webp"),"width":"104"}})],1),_c(VSpacer),_c('night-switch'),_c('importer-menu'),_c('notifications-menu'),_c('user-profile-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }